import { Link } from 'react-router-dom';
import '../styles/components/PackagesSection.css';  
import image1 from '../data/Images/course1.jpg'
import image2 from '../data/Images/course2.jpg'
import image3 from '../data/Images/course3.jpg'
import image4 from '../data/Images/course4.jpg'
import { FaCheckCircle } from 'react-icons/fa';


const PackagesSection = () => {
  return (
    <div id="packages-section" className="packages-container">
      <div className="packages-hero">
        <h2 className="packages-title">Best Flight Deals & Vacation Packages 2024</h2>
        <p className="packages-description">
            Save up to 40% on flights with our exclusive travel packages. Compare prices from 500+ airlines worldwide and choose from economy, business, or first-class options. All packages include flights, accommodation, and travel insurance with flexible booking policies and 24/7 customer support.</p>
      </div>

      <div className="packages-list">

        <div className="package-item">

          <img src={image1} alt="Tropical Paradise Package" className="package-image" />
          <h3 className="package-name">Tropical Beach Holiday Packages</h3>
          <p className="package-info">Book affordable tropical vacation packages with flights to Maldives, Bali, Thailand. Includes luxury resort accommodation, meals, and travel insurance.</p>
          <Link to="/package/1" className="view-detail"><button>View Details</button></Link>
        </div>

        <div className="package-item">

          <img src={image2} alt="European Cultural Package" className="package-image" />
          <h3 className="package-name">Europe Travel Packages</h3>
          <p className="package-info">Explore Europe's top destinations with guided cultural tours. Visit Paris, Rome, Barcelona with flights, hotels, and museum passes included.</p>
          <Link to="/package/2" className="view-detail"><button>View Details</button></Link>
        </div>

        <div className="package-item">

          <img src={image3} alt="Adventure Package" className="package-image" />
          <h3 className="package-name">Adventure Travel Packages</h3>
          <p className="package-info">Book adventure travel packages for hiking, skiing, diving worldwide. Includes flights to New Zealand, Costa Rica, Nepal with expert guides.</p>
          <Link to="/package/3" className="view-detail"><button>View Details</button></Link>
        </div>

        <div className="package-item">

          <img src={image4} alt="Luxury Package" className="package-image" />
          <h3 className="package-name">Luxury Travel Packages</h3>
          <p className="package-info">Premium luxury travel with first-class flights, 5-star hotels, and VIP experiences. Destinations include Dubai, Tokyo, Swiss Alps.</p>

          <Link to="/package/4" className="view-detail"><button>View Details</button></Link>
        </div>

      </div>

      {/* Why Choose Us Section - Separate from packages */}
      <div className="package-benefits">
        <h2>Why Book Flights & Travel Packages With Us</h2>
        <div className="benefits-list">
          {[
            "24/7 Multilingual Customer Support",
            "Lowest Price Guarantee & Price Match",
            "IATA Certified Travel Experts",
            "Secure SSL Payment Processing",
            "Free Flight Change & Cancellation",
            "500+ Airlines & Global Routes",
            "Instant E-Ticket Confirmation",
            "Comprehensive Travel Insurance",
          ].map((benefit, index) => (
                  <div key={index} className="items">
                    <div className="benefit-item">
                        <div className="benefit-item1">
                          <FaCheckCircle className="check-icon" />
                        </div>
                        <div className="benefit-item2">
                          <span>: {benefit}</span>
                        </div>
                    </div>
                  </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PackagesSection;
